export * from './settings.component';
export * from './apperance/apperance.component';
export * from './avatar/avatar.component';
export * from './notifications/notifications.component';
export * from './you/you.component';
